module.exports = {"340702198":"铜官山区虚镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/340702.json
// module id = 1190
// module chunks = 0